<template>
  <transition name="fade-scale">
    <div v-if="modelValue" class="modal-overlay" @click.self="close">
      <div class="modal-content">
        <button class="close-btn" @click="close" aria-label="Close modal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="#5F6368" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke="#5F6368" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="doc-header">
          <i data-v-6ed37b07="" class="fas fa-2x fa-user-md" style="color: #fff;background: gray;border-radius: 50%;padding: 0.7rem;"></i>
          <div class="doc-info">
            <h2 class="doc-name">{{ doctor.FullName || 'Unidentified Doctor' }}</h2>
            <p class="doc-specialty">{{ doctor.Title  || '-'}}</p>
          </div>
        </div>

        <div class="doc-details">
          <div class="detail-section">
            <h3 class="section-title">Professional Information</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">Specialization</span>
                <span class="detail-value">{{ doctor.Specialization || 'Specialization not specified' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Practice</span>
                <span class="detail-value">{{ doctor.Practice || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Subspecialties</span>
                <span class="detail-value">{{ doctor.SubSpecialization || '-' }}</span>
              </div>
            </div>
          </div>

          <div class="detail-section">
            <h3 class="section-title">Location</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">Address</span>
                <span class="detail-value">{{ doctor.Address || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">City</span>
                <span class="detail-value">{{ doctor.City || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">State</span>
                <span class="detail-value">{{ doctor.State || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">ZIP Code</span>
                <span class="detail-value">{{ doctor.Zip || '-' }}</span>
              </div>
            </div>
          </div>

          <div class="detail-section">
            <h3 class="section-title">Contact</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">Phone</span>
                <a v-if="doctor.Phone || doctor.CellNumber" :href="`tel:${doctor.Phone || doctor.CellNumber}`" class="detail-value link">
                  {{ doctor.Phone || doctor.CellNumber }}
                </a>
                <span v-else class="detail-value">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DoctorDetailsModal',
  props: {
    modelValue: { type: Boolean, required: true },
    doctor: { type: Object, required: true }
  },
  emits: ['update:modelValue'],
  methods: {
    close() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>

<style>
/* Smooth transition */
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s ease;
}
.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

/* Modal content */
.modal-content {
  background: #ffffff;
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  max-width: 640px;
  position: relative;
  overflow-y: auto;
  max-height: 90vh;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  animation: slide-up 0.3s ease;
}

@keyframes slide-up {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Close button */
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #5F6368;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #202124;
}

.close-btn svg {
  width: 20px;
  height: 20px;
}

/* Doctor header */
.doc-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.doc-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #E8EAF6; 
  display: flex;
  align-items: center;
  justify-content: center;
}

.doc-avatar svg {
  width: 32px;
  height: 32px;
}

.doc-info {
  flex: 1;
  text-align: start;
}

.doc-name {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: #202124;
}

.doc-specialty {
  font-size: 1rem;
  margin: 4px 0 0;
  color: #3F51B5;
  font-weight: 700;
}

/* Details sections */
.doc-details {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-section {
  border-bottom: 1px solid #E0E0E0;
  padding-bottom: 16px;
}

.detail-section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 16px;
  color: #202124;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: start;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-label {
  font-size: 0.875rem;
  color: #202124;;
  font-weight: 500;
  text-align: start;
  font-weight: 700;
}

.detail-value {
  font-size: 1rem;
  color: #202124;
  font-weight: 400;
  word-break: break-word;
  text-align: start;
}

.link {
  color: #3F51B5;
  text-decoration: none;
  transition: color 0.2s ease;
}

.link:hover {
  color: #303F9F;
  text-decoration: underline;
}

/* Responsiveness */
@media (max-width: 600px) {
  .modal-content {
    padding: 24px 16px;
  }
  
  .detail-grid {
    grid-template-columns: 1fr;
  }
  
  .doc-header {
    flex-direction: column;
    text-align: center;
  }
  
  .doc-info {
    text-align: center;
  }
}
</style>